<template>
  <div class="loginBox">
    <el-dialog
      title="提示"
      :visible.sync="showLogin"
      width="480px"
      @touchmove.native.prevent
      :class="{
        dialog1: true,
        dialog2: this.deviceClass != 'pc',
      }"
      :custom-class="this.deviceClass == 'pc' ? 'loginDialog' : 'loginDialog2'"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <div class="d-header">
          <div class="closeBox" @click="handleClose">
            <svg-btn class="icon" icon-class="icon-model-close"></svg-btn>
          </div>
        </div>
        <div class="d-content">
          <div class="loginBt" @click="handleLogin">
            <img
              class="feemooIcon"
              :src="$utils.getPng('icon-gfans-feemoo')"
              alt=""
            />
            <span class="title2">Feemoo快捷登录</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'loginShow',
  props: {
    tips: {
      type: String,
      default: '通过Feemoo授权登录/注册',
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['showLogin']),
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  methods: {
    //提交方法
    handleLogin: _.debounce(
      function () {
        if (this.$store.state.showLoginShort == '/login') {
          this.$router.push({
            path: '/login',
          })
        } else {
          window.location.href = this.$store.state.showLoginShort
        }
        this.handleClose()
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    handleClose() {
      this.$store.commit('setShowLoginShort', '')
      this.$store.commit('setShowLogin', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog2 {
  padding: 0 32px;
}
::v-deep .v-modal {
  opacity: 0.4;
}
::v-deep .el-dialog {
  margin: 0 !important;
  border-radius: 16px;
  box-shadow: none;
  background: #ffffff;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 20px 24px 24px 24px;
    border-radius: 16px;
    color: #2c2c2c;
  }
  .d-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .closeBox {
      position: absolute;
      right: 20px;
      top: 20px;
      padding: 0 4px;
      height: 24px;
      cursor: pointer;
      border-radius: 6px;
      font-size: 12px;
      color: #8a8b92;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        color: #2c2c2c;
        background-color: #f6f6f6;
      }
      .icon {
        width: 16px;
        height: 16px;
      }
    }
    .left {
      display: flex;
      align-items: center;
      span {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
    .fm-button {
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
  .d-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    button {
      border-radius: 18px;
      &:last-child {
        margin-left: 12px;
      }
    }
  }
}
::v-deep .loginDialog {
  width: 480px;
  .el-dialog__body {
    padding: 20px 24px 32px 24px;
  }
  .d-header {
    .left {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
  .d-content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 56px 0 28px 0;
    .loginBt {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f67942;
      border-radius: 26px;
      width: 324px;
      height: 52px;
      cursor: pointer;
      &:hover {
        background: #ff9c71;
      }
      &:active {
        background: #d84f13;
      }
      .feemooIcon {
        width: 40px;
        height: 40px;
        object-fit: cover;
      }
      .title2 {
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
      }
    }
  }
  .d-footer {
    justify-content: center;
    button {
      width: 164px;
      height: 36px;
      margin-left: 0 !important;
    }
  }
}
::v-deep .loginDialog2 {
  max-width: 480px !important;
  width: 100% !important;
  .el-dialog__body {
    padding: 20px 24px 32px 24px;
  }
  .d-header {
    .left {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
  .d-content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 44px 0 16px 0;
    .title {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #2c2c2c;
    }
    .loginBt {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f67942;
      border-radius: 26px;
      width: 324px;
      height: 48px;
      cursor: pointer;
      &:hover {
        background: #ff9c71;
      }
      &:active {
        background: #d84f13;
      }
      .feemooIcon {
        width: 40px;
        height: 40px;
        object-fit: cover;
      }
      .title2 {
        font-weight: 600;
        font-size: 14px;
        color: #ffffff;
        line-height: 24px;
      }
    }
  }
  .d-footer {
    justify-content: center;
    button {
      width: 164px;
      height: 36px;
      margin-left: 0 !important;
    }
  }
}
</style>
